export default "__VITE_ASSET__CIEWhDEJ__"